import { Component, Input } from '@angular/core';
import { SizingStatus } from '../deploy-sizing.component';
@Component({
  selector: 'app-configure',
  templateUrl: './configure.component.html',
  styleUrl: './configure.component.scss',
  standalone: false
})
export class ConfigureComponent {
    @Input() active = false;
    @Input() completed = false;
    @Input() sizingStatus!: SizingStatus;
    SizingStatus = SizingStatus

      
    ngOnInit(): void {
      
    }
}
